export default {
  // heading: 'InterVariable, -apple-system, system-ui, sans-serif',
  heading: 'IBM Plex Sans Thai',
  // body: 'InterVariable, -apple-system, system-ui, sans-serif',
  body: 'IBM Plex Sans Thai',
}
